module.exports = __webpack_public_path__ + "static/media/dark_logo.39eca2a6.svg";